"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShadeSize = void 0;
let ShadeSize = exports.ShadeSize = /*#__PURE__*/function (ShadeSize) {
  ShadeSize["Medium"] = "medium";
  ShadeSize["Small"] = "small";
  ShadeSize["Inline"] = "inline";
  return ShadeSize;
}({});
